/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */
import React from 'react';
import {
    object, func,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import AddIcon from '@material-ui/icons/Add';

const styles = (theme) => ({
    addImage: {
        width: 50,
        height: 50,
        fontSize: 24,
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: 'auto',
        color: theme.palette.cgc?.grey || '#a4a4a4',
        border: `3px solid ${theme.palette.cgc?.grey || '#a4a4a4'}`,
    },
    imgFont: {
        fontSize: 10,
        color: theme.palette.cgc?.grey || '#a4a4a4',
    },
    imgMessage: {
        fontSize: 12,
        color: theme.palette.cgc?.grey || '#666',
    },
});
const addImageIcon = <AddIcon />;
const SelectPersonalizeImage = ({ classes, handleImage }) => (
    <Grid>
        <input type="file" id="selectImage" hidden placeholder="Upload Image" onChange={(e) => handleImage(e)} />
        <label className={classes.addImage} htmlFor="selectImage">{addImageIcon}</label>
        <span className={classes.imgFont}>Upload Image</span><br />
        <span className={classes.imgMessage}>Please upload JPG, JPEG or PNG file.</span>
    </Grid>
);
SelectPersonalizeImage.propTypes = {
    classes: object.isRequired,
    handleImage: func.isRequired,
};
export default withStyles(styles)(SelectPersonalizeImage);
